export default __webpack_public_path__ + "static/media/SAS Chat Tone 1.5ea77919.mp3";